export default "__VITE_ASSET__Ch3OagPY__"